'use client'

import * as React from 'react'

// Plain-<img> wrapper for third-party chrome (Product Hunt badges,
// network-icon CDNs) that should vanish rather than show a broken-image
// glyph when the host is slow, blocked or gone. Unlike ResilientImg it
// has no substitute image: a missing badge beats a wrong one.
export function HideOnErrorImg({
  fallback = null,
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement> & { fallback?: React.ReactNode }) {
  const [dead, setDead] = React.useState(false)
  if (dead) return <>{fallback}</>
  // eslint-disable-next-line @next/next/no-img-element
  return <img {...props} alt={props.alt ?? ''} onError={() => setDead(true)} />
}
